export const GEF = '.gef'
export const CSV = '.csv'
export const ZIP = '.zip'

export const DESCRIPTION_FILE_NAME = 'Field Geological Descriptions.csv'
export const DETAILS_FILE_NAME = 'Location Details.csv'
export const DATA_FILE_NAME = 'Static Cone Penetration Tests - Data.csv'
export const GENERAL_FILE_NAME = 'Static Cone Penetration Tests - General.csv'
